// @flow
import type { DeliveryResourcesActionType } from './actions';
import type {
  DeliveryResourceType as TrpcDeliveryResourceType,
  DeliveryMethodType,
  AddressType,
} from 'digicel-kaizen-library';

export const initialState: DeliveryResourcesStateType = [];

export default (state: DeliveryResourcesStateType = initialState, action: DeliveryResourcesActionType) => {
  switch (action.type) {
    case 'FETCH_DELIVERY_RESOURCES_SUCCESS':
      return action.payload.deliveryResources;
    default:
      return state;
  }
};

export type DeliveryResourceType = {
  deliveryAddress: ?AddressType,
  deliveryId: string,
  deliveryMethod: ?DeliveryMethodType,
  deliveryName?: string,
  isLinkedWithActivableSubscription: boolean,
  orderDate: number,
  ouid: string,
  productOuid: string,
  status: 'shipped' | 'delivered' | 'inPreparation',
  trackingId: ?string,
  trackingLink: ?string,
};

type DeliveryResourcesStateType = ?Array<TrpcDeliveryResourceType>;
